/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_DamagedInputs */

const tr_geliver_substatus_package_damaged = /** @type {(inputs: Geliver_Substatus_Package_DamagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Hasarlı`)
};

const en_geliver_substatus_package_damaged = /** @type {(inputs: Geliver_Substatus_Package_DamagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package Damaged`)
};

const de_geliver_substatus_package_damaged = /** @type {(inputs: Geliver_Substatus_Package_DamagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket beschädigt`)
};

const ru_geliver_substatus_package_damaged = /** @type {(inputs: Geliver_Substatus_Package_DamagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посылка повреждена`)
};

/**
* | output |
* | --- |
* | "Package Damaged" |
*
* @param {Geliver_Substatus_Package_DamagedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_damaged = /** @type {((inputs?: Geliver_Substatus_Package_DamagedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_DamagedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_damaged(inputs)
	if (locale === "de") return de_geliver_substatus_package_damaged(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_damaged(inputs)
	return tr_geliver_substatus_package_damaged(inputs)
});